// extracted by mini-css-extract-plugin
export default {"container":"ProfileHeader_container__PCOaw","mainTitle":"ProfileHeader_mainTitle__1as8U"};